<script lang="ts" setup>
import { computed, ref } from 'vue'
import { useInfiniteScroll } from '@vueuse/core'
import { api } from '@/api'

const records = ref<any[]>([])
const page = ref(1)
const fetching = ref(false)
const ending = ref(false)
const error = ref<any>()
const pagination = computed(() => ({
  pageIndex: page.value,
  pageSize: 20,
}))
async function fetchFeed() {
  fetching.value = true
  try {
    const { data } = await api.get<any, GetMemberGetrechargerecordlistResponse>('/member/getRechargeRecordList', { params: { ...pagination.value } })
    records.value = [...records.value, ...data.records]
    if (page.value >= data.pages)
      ending.value = true
    else
      page.value += 1
  }
  catch (_error) {
    error.value = _error
  }
  finally {
    fetching.value = false
  }
}
const infiniteRef = ref<HTMLElement>()
useInfiniteScroll(infiniteRef,
  async () => {
    if (fetching.value || ending.value || error.value)
      return
    await fetchFeed()
  },
  { distance: 50 },
)
</script>

<template>
  <div ref="infiniteRef" class="h-screen overflow-scroll bg-white">
    <BasicNavbar />

    <div v-if="!fetching && page === 1 && records.length === 0" class="mt-11 pt-15vh w-full text-center flex flex-col justify-center">
      <BizBlockEmpty title="暂无充值记录" />
    </div>
    <div v-else class="pt-44px px-5">
      <div v-for="item in records" :key="item.orderId" class="h-77px flex justify-between items-center border-b">
        <div>
          <p class="text-14px font-bold">
            {{ item.title }}
          </p>
          <p class="mt-6px text-13px text-#AFAFAF">
            {{ item.rechargeTime }}
          </p>
        </div>
        <div class="text-13px">
          <p>{{ item.vipFlag ? `+${item.vipDay}天` : `+${item.coinNum}金币` }}</p>
        </div>
      </div>
    </div>
    <div v-if="ending && records.length" class="py-15px text-13px text-#999 text-center">
      我们是有底线的~
    </div>
    <div v-else-if="fetching" class="py-15px flex items-center justify-center space-x-4 text-13px text-#999">
      <div class="animate-spin">
        <i-icon-park-outline-loading />
      </div>
      <p>加载中...</p>
    </div>
  </div>
</template>
